export default __webpack_public_path__ + "static/media/4b5e92f824d0ca7b8bce6c1cb20dac19.svg";